import Factory from "../Factory";
import { FactoryInterface } from "../FactoryInterface";

import { Subscription } from "../Entities/Subscription/Subscription";
import { SubscriptionInterface } from "../Entities/Subscription/SubscriptionInterface";
import Store from "../../Store/Store";

class SubscriptionFactory extends Factory implements FactoryInterface {

  public create(data: any): SubscriptionInterface {
    return new Subscription({
      id: data.id,
      userId: data.userId,
      subscriptionType: Store.getConfigurator().getState().globalTypes?.SubscriptionType?.[data.subscriptionTypeId],
      entityId: data.entityId,
      subscribed: data.subscribed
    });
  }

  public reinitialize(data: any): SubscriptionInterface {
    return new Subscription({
      ...data
    });
  }
}

export default new SubscriptionFactory();
